// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wu0sy","top":"styles_top__2r8Yb","left":"styles_left__-VYeO","description":"styles_description__QEAPu"};